import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_352: DocMigration = {
  maxSchemaVersion: "0.0.352",
  description: "Remove 'PLAN_EDGE_NOTE' annotations",
  apply(json: any) {
    for (const settingId in json.settings) {
      if ("propTypes" in json.settings[settingId]) {
        for (const propId in json.settings[settingId]["propTypes"]) {
          if ("plumbingTag" in json.settings[settingId]["propTypes"][propId]) {
            delete json.settings[settingId]["propTypes"][propId]["plumbingTag"];
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_352;
